import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Input } from '@angular/core';
// import * as traducaoDatatable from '../../../../assets/plugins/datatable-translate/pt-BR.json';
import { UtilsService } from '../../../../@core/@service/utils/utils';
import { SolicitacaoBeneficioDependenteService } from 'src/app/@core/@service/solicitacao/beneficio-dependente/beneficio-dependente.service';
import Swal from 'sweetalert2';
import { CadastroColaboradorService } from 'src/app/@core/@service/cadastro/colaborador/colaborador.service';
import { SolicitacaoBeneficioDependenteStatusEnum } from 'src/app/@core/@enum/enum';



@Component({
  selector: 'app-aprovacao-beneficio-dependente',
  templateUrl: './beneficio-dependente.component.html',
  styleUrls: ['./beneficio-dependente.component.scss']
})
export class AprovacaoBeneficioDependenteComponent implements OnInit {

  gridData = [];

  colaboradorGridData = [];

  colaboradorSelected = '';

  gestorSelected

  statusSelected = '';

  colaboradorLogged = '';

  statusList: Array<any>;

  dataTable: any;

  @ViewChild('grid', { static: true }) grid: ElementRef;

  @ViewChild('gridModalColaborador', { static: true }) gridModalColaborador: ElementRef;

  @ViewChild('gridModalGestor', { static: true }) gridModalGestor: ElementRef;

  constructor(
    private utilService: UtilsService,
    private moduleService: SolicitacaoBeneficioDependenteService,
    private colaboradorService: CadastroColaboradorService,
  ) { }

  ngOnInit() {
    const currUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.colaboradorLogged = currUser ? currUser.UsuarioColaboradorId : '';
    this.loadDataTable([]);
  }


  reprovar(data) {
    Swal.fire({
      position: 'top',
      title: 'Você tem certeza que deseja reprovar essa solicitação?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3c8dbc',
      cancelButtonColor: '#DD4B39',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      if (result.isConfirmed) {
        if (data.SolicitacaoStatusId == SolicitacaoBeneficioDependenteStatusEnum.EM_ANALISE_APROVACAO) {
          this.moduleService.reprovarSolicitacao(data.Id).subscribe(
            res => {
              this.utilService.alertSwal('reprove-success');
              this.getDataGrid();
            },
            err => {
              this.utilService.alertSwal('reprove-error');
            }
          );
        } else {
          this.moduleService.reprovarCancelamento(data.Id).subscribe(
            res => {
              this.utilService.alertSwal('reprove-success');
              this.getDataGrid();
            },
            err => {
              this.utilService.alertSwal('reprove-error');
            }
          );
        }
      }
    })
  }

  aprovar(data) {
    Swal.fire({
      position: 'top',
      title: 'Você tem certeza que deseja aprovar essa solicitação?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3c8dbc',
      cancelButtonColor: '#DD4B39',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      if (result.isConfirmed) {
        if (data.SolicitacaoStatusId == SolicitacaoBeneficioDependenteStatusEnum.EM_ANALISE_APROVACAO) {
          this.moduleService.aprovarSolicitacao(data.Id).subscribe(
            res => {
              this.utilService.alertSwal('approve-success');
              this.getDataGrid();
            },
            err => {
              this.utilService.alertSwal('approve-error');
            }
          );
        } else {
          this.moduleService.aprovarCancelamento(data.Id).subscribe(
            res => {
              this.utilService.alertSwal('approve-success');
              this.getDataGrid();
            },
            err => {
              this.utilService.alertSwal('approve-error');
            }
          );
        }
      }
    })
  }

  getValuesFromInput() {
    return {
      GestorId: this.gestorSelected,
      ColaboradorId: this.colaboradorSelected,
    }
  }


  getDataGrid() {
    this.moduleService.pesquisar(this.colaboradorSelected ? this.colaboradorSelected : this.colaboradorLogged).subscribe(
      res => {
        this.gridData = res.filter(val => val.Id != 0).map(val =>
          ({
            id: val.Id,
            nomeDependente: val.Dependente ? val.Dependente.Nome : '-',
            nomeTitular: val.Dependente ? val.Dependente.TitularNome : '-',
            beneficio: val.Beneficio ? val.Beneficio.Nome : '-',
            regra: val.Beneficio ? val.Beneficio.RegraDesconto : '-',
            tipo: val.Beneficio ? (val.Beneficio.BeneficioTipo ? val.Beneficio.BeneficioTipo.Nome : '-') : '-',
            custo: val.Beneficio ? val.Beneficio.CustoBeneficio : '-',
            status: val.SolicitacaoStatus ? val.SolicitacaoStatus.Nome : '-',
            dataSolicitacao: val.DataSolicitacao,
            dataConclusao: val.DataConclusao,
            ...val,
          })
        ).sort(this.utilService.dynamicSort('nome'));
        this.loadDataTable(this.gridData);
      },
      err => {
        console.log(err);
      }
    );
  }

  clearInputvalues() {
    // Zera os campos
    this.colaboradorSelected = '';
    $('#txtNomeColaborador').val('');
  }

  openModal(idModal, data = {}) {
    this.closeModal(idModal);
    if (idModal == 'modalColaborador') {
      if ($('#txtNomeColaborador').val().toString().length > 0) {
        this.colaboradorService.buscarDependentePorNome($('#txtNomeColaborador').val().toString()).subscribe(
          res => {
            this.colaboradorGridData = res.map(val =>
              ({
                id: val.Id,
                nome: val.Nome,
                cpf: val.CPF,
                ...val
              })
            ).sort(this.utilService.dynamicSort('nome'));
            this.loadDataTableModalColaborador(this.colaboradorGridData);

            ($(`#${idModal}`) as any).modal('show');
          },
          err => {
            Swal.fire({
              position: 'top',
              icon: 'error',
              title: 'Ocorreu um erro ao buscar a lista de \n colaboradores!',
              showConfirmButton: false,
              timer: 2000
            });
            console.log(err);
          }
        );
      }
    }
  }

  closeModal(idModal) {
    ($(`#${idModal}`) as any).modal('hide');
  }


  pesquisar() {
    this.getDataGrid();
  }

  loadDataTable(data) {
    let self = this;
    this.dataTable = $(this.grid.nativeElement);
    this.dataTable.DataTable({
      "data": data,
      "bDestroy": true,
      "columns": [
        {
          "data": "nomeDependente"
        },
        {
          "data": "nomeTitular"
        },
        {
          "data": "beneficio"
        },
        {
          "data": "regra"
        },
        {
          "data": "tipo"
        },
        {
          "data": 'custo', "orderable": true, "render": function (data) {
            return 'R$ ' + data.toLocaleString('pt-br', { minimumFractionDigits: 2 });
          }
        },
        {
          "data": "status"
        },
        {
          "data": 'dataSolicitacao', "orderable": true, "render": function (data, type, row) {
            return data ? new Date(data).toLocaleDateString('pt-br') : '-';
          }
        },
        {
          "data": 'dataConclusao', "orderable": true, "render": function (data, type, row) {
            return data ? new Date(data).toLocaleDateString('pt-br') : 'Não Concluído';
          }
        },
        {
          "data": '', "orderable": false, "render": function (data, type, row) {
            if (row.SolicitacaoStatus && row.SolicitacaoStatus.Nome.toString().toLowerCase().includes('análise')) {
              if(row.SolicitacaoStatusId == SolicitacaoBeneficioDependenteStatusEnum.EM_ANALISE_APROVACAO) {
                return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-check" style="color: rgb(29, 136, 136); border: 0px; background-color: transparent;" title="Aprovar Solicitação"> </button></div>';
              } else {
                return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-check" style="color: rgb(29, 136, 136); border: 0px; background-color: transparent;" title="Aprovar Cancelamento"> </button></div>';
              }
            } else {
              return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-check" style="pointer-events: none; color: #9c9b9b; border: 0px; background-color: transparent;" title="Aprovar"> </button></div>';
            }
          }
        },
        {
          "data": '', "orderable": false, "render": function (data, type, row) {
            if (row.SolicitacaoStatus && row.SolicitacaoStatus.Nome.toString().toLowerCase().includes('análise')) {
              if(row.SolicitacaoStatusId == SolicitacaoBeneficioDependenteStatusEnum.EM_ANALISE_APROVACAO) {
                return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-times" style="color: rgb(136, 68, 29); border: 0px; background-color: transparent;" title="Reprovar Solicitação"> </button></div>';
              } else {
                return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-times" style="color: rgb(136, 68, 29); border: 0px; background-color: transparent;" title="Reprovar Cancelamento"> </button></div>';
              }
             
            } else {
              return '<div style="vertical-align: middle; text-align:center;"><button type="button" class="fa fa-times" style="pointer-events: none; color: #9c9b9b; border: 0px; background-color: transparent;" title="Reprovar"> </button></div>';
            }
          }
        },
      ],
      "createdRow": function (row, data, index) {
        $($(row).children()[9]).on("click", function (e) {
          // aprovar
          if (data.SolicitacaoStatus && data.SolicitacaoStatus.Nome.toString().toLowerCase().includes('análise')) {
            self.aprovar(data);
          }
        });
        $($(row).children()[10]).on("click", async function (e) {
          // reprovar
          if (data.SolicitacaoStatus && data.SolicitacaoStatus.Nome.toString().toLowerCase().includes('análise')) {
            self.reprovar(data);
          }
        });
      },
      "paging": true,
      "bAutoWidth": false,
      "lengthChange": true,
      "searching": true,
      "ordering": true,
      "info": true,
      "autoWidth": true,
      "language": this.utilService.getDatatableTranslate(),
    });
  }

  loadDataTableModalColaborador(data) {
    let self = this;
    this.dataTable = $(this.gridModalColaborador.nativeElement);
    this.dataTable.DataTable({
      "data": data,
      "bDestroy": true,
      "columns": [
        {
          "data": "nome"
        },
        {
          "data": "cpf"
        },
      ],
      "createdRow": function (row, data, index) {
        $($(row).children()).on("click", function (e) {
          self.colaboradorSelected = data.id;
          $('#txtNomeColaborador').val(data.nome);
          self.closeModal('modalColaborador');
        });
      },
      "paging": true,
      "bAutoWidth": false,
      "lengthChange": false,
      "searching": false,
      "ordering": false,
      "info": false,
      "autoWidth": false,
      "language": this.utilService.getDatatableTranslate(),
    });
  }

  loadDataTableModalGestor(data) {
    let self = this;
    this.dataTable = $(this.gridModalGestor.nativeElement);
    this.dataTable.DataTable({
      "data": data,
      "bDestroy": true,
      "columns": [
        {
          "data": "nome"
        },
        {
          "data": "cpf"
        },
      ],
      "createdRow": function (row, data, index) {
        $($(row).children()).on("click", function (e) {
          self.gestorSelected = data.id;
          $('#txtNomeGestor').val(data.nome);
          self.closeModal('modalGestor');
        });
      },
      "paging": true,
      "bAutoWidth": false,
      "lengthChange": false,
      "searching": false,
      "ordering": false,
      "info": false,
      "autoWidth": false,
      "language": this.utilService.getDatatableTranslate(),
    });
  }

}
